export { BeePreloaderComponent } from './bee-preloader.component';
export { BeePreloaderModule } from './bee-preloader.module';
